import React, { Component } from 'react';
import DatePicker from '../common/datepicker';
import { TableHeaderColumn } from 'react-bootstrap-table';
import UserSearch from '../common/userSearch';
import DataGrid from '../common/dataGrid';
import dateHelper from '../../helpers/date.js';
import { CheckBox, ApplyAndReset } from '../common/forms';
import enums from '../../config/enums';
import CSVExport from '../common/CSVExport';

class DoctorAdvicesSearch extends React.Component {
    constructor(props) {
        super(props);
        var DefaultParams = getDefaultParams();
        /* console.log(DefaultParams.fromDate);
        console.log(DefaultParams.toDate);*/
        this.state = {
            fromDate: DefaultParams.fromDate.toLocaleDateString(),
            toDate: DefaultParams.toDate.toLocaleDateString(),
            user: DefaultParams.user
        }
    }

    changeFrom(date) {
        this.setState({ fromDate: date });
    }

    changeTo(date) {
        this.setState({ toDate: date });
    }

    getSearchParams() {
        var params = this.state;

        params.user = this
            ._userSearch
            .getUser();

        return params;
    }

    setSearchParams(params) {
        this.setState(params);
    }

    render() {
        console.log("in render: " + this.state.fromDate);
        return (
            <div className='SearchContainer' style={SearchContainerStyle}>
                <div className='float-left right-border '>
                    <DatePicker
                        className='display-table'
                        Label='From date'
                        type="start"
                        startDate={this.state.fromDate}
                        endDate={this.state.toDate}
                        onChange={this
                            .changeFrom
                            .bind(this)} />
                    <DatePicker
                        className='display-table'
                        Label='To date'
                        type="end"
                        startDate={this.state.fromDate}
                        endDate={this.state.toDate}
                        ContainerType='input'
                        onChange={this
                            .changeTo
                            .bind(this)} />
                </div>
                <div className='float-left'>
                    <h5>Patient name</h5>
                    <UserSearch
                        Value={this.state.user}
                        ref={(userSearch) => {
                            this._userSearch = userSearch;
                        }} />
                </div>
                <div className='float-left'>
                    <ApplyAndReset
                        Search={this
                            .props
                            .Search
                            .bind(this)}
                        ApplyReset={this
                            .props
                            .ApplyReset
                            .bind(this)} />
                </div>
                <div className='float-left'>
                    <CSVExport 
                    ajaxUrl='/data/getAllEverDoctorsAdvices' 
                    parameters={{
                        DoctorID: this.props.doctorID
                    }} 
                    dbKeys={['ID', 'PatientName', 'Created', 'LLLT', 'RF', 'EMT', 'Comment']} 
                    csvKeys={['ID', 'Patient Name', 'Date', 'LLLT', 'RF', 'ELP', 'Comment']}
                    dataFormatters={[null, null, null, LLLTFormaterCSV, RFFormaterCSV, RFFormaterCSV, null]}
                    fileName={'Plans_' + dateHelper.fromDateToStrWithTimeForFileName(Date.now()) + '.csv'}/>
                </div>
            </div>
        )
    }
}

module.exports = class DoctorAdvices extends React.Component {
    constructor(props) {
        super(props);

        this.moreDetailsFormatter = this.moreDetailsFormatter.bind(this);
    }

    isExpandable(row) {
        //if (row.Details == null)    return false;
        return true;
    }

    Search() {
        var params = this
            ._doctorAdvicesSearch
            .getSearchParams();

        this.setState({ params });
        this
            ._dataGrid
            .setNewParameters(params);
    }

    trClassFormat(row, rowIndex) {
        if (row.isExpanded)
            return 'tr-expanded';

        // row is the current row data
        return rowIndex % 2 === 0
            ? "tr-odd"
            : "tr-even"; // return class name.
    }

    expandComponent(row) {
        return (
            <table className='exapandbleRowTable'>
                <tbody>
                    <tr>
                        <td></td>
                        <td></td>
                        <td>{row.LLLT != null ? row.LLLT.allData : ''}</td>
                        <td>{row.EMT != null ? row.EMT.allData : ''}</td>
                        <td>{row.RF != null ? row.RF.allData : ''}</td>
                        <td></td>
                        <td width='19'></td>
                    </tr>
                </tbody>
            </table>
        );
    }


    ApplyReset() {
        this.setState(getDefaultParams());

        this
            ._dataGrid
            .setNewParameters(getDefaultParams());

        this
            ._doctorAdvicesSearch
            .setSearchParams(getDefaultParams());
    }

    /* More Details */
    moreDetailsFormatter(cell, row, enumObject, index) {
        if (row.isExpanded != undefined && row.isExpanded == true) {
            return (
                <div className='MoreInfo' onClick={() => this.rowClick(row)}>-</div>
            );
        }
        else {
            return (
                <div className='MoreInfo' onClick={() => this.rowClick(row)}>+</div>
            );
        }
    }

    rowClick(row) {
        if (row.isExpanded == undefined || row.isExpanded == false)
            row.isExpanded = true;
        else
            row.isExpanded = false;
    }

    render() {
        var params = {
            DoctorID: this.props.doctorID
        };
        return (
            <div>

                <DoctorAdvicesSearch
                    ref={(doctorAdvicesSearch) => {
                        this._doctorAdvicesSearch = doctorAdvicesSearch;
                    }}
                    ApplyReset={this
                        .ApplyReset
                        .bind(this)}
                    Search={this
                        .Search
                        .bind(this)} doctorID={this.props.doctorID} />
                <DataGrid
                    ajaxUrl='/data/getAllEverDoctorsAdvices'
                    ID='doctorAdvices'
                    parameters={params}
                    ExpandableRow={this.isExpandable}
                    trClassFormat={this.trClassFormat}
                    ExpandComponent={this.expandComponent}>
                    <TableHeaderColumn dataField='PatientName' isKey={true} dataSort>Patient Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='Created' dataSort>Date</TableHeaderColumn>
                    <TableHeaderColumn dataField='LLLT' dataFormat={LLLTFormater} dataSort>LLLT</TableHeaderColumn>
                    <TableHeaderColumn dataField='RF' dataFormat={RFFormater} dataSort>RF</TableHeaderColumn>
                    <TableHeaderColumn dataField='EMT' dataFormat={EMTFormater} dataSort>ELP</TableHeaderColumn>
                    <TableHeaderColumn dataField='Comments' dataSort>Comment</TableHeaderColumn>
                    <TableHeaderColumn dataFormat={this.moreDetailsFormatter} dataField='' width='35'></TableHeaderColumn>
                </DataGrid>
            </div>
        )
    }
}

const SearchContainerStyle = {
    width: '800px',
    height: '120px'
};

var MoreDetailsContainer = React.createClass({
    MoreDetailsRow: function (key, data) {
        return <div key={key}>{data}</div>;
    },
    createContainer: function (data) {
        var columnData = [];
        for (var prop in data) {
            var rowData = prop + " = " + data[prop];
            columnData.push(this.MoreDetailsRow(prop, rowData));
        }
        return columnData;
    },
    render: function () {
        return (
            <div>{this.createContainer(this.props.data)}</div>
        )
    }
});

var weekday = new Array(7);
weekday[0] = "Sunday";
weekday[1] = "Monday";
weekday[2] = "Tuesday";
weekday[3] = "Wednesday";
weekday[4] = "Thursday";
weekday[5] = "Friday";
weekday[6] = "Saturday";

function LLLTFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {
        cell.firstRow = "Wave = " + cell.Wave;

        var allData = [];
        if (cell.PowerLevel658)
            allData.push(<div key="658">Power 658 = {cell.PowerLevel658}</div>);
        if (cell.PowerLevel852)
            allData.push(<div key="852">Power 852 = {cell.PowerLevel852}</div>);
        allData.push(<div key="duration">Duration = {cell.Duration}</div>);

        allData = allData.concat(parseRepeatData(cell.Repeat));

        cell.allData = allData;

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}

function LLLTFormaterCSV(cell) {
    if (cell == null) {
        return "";
    }

    var allData = [];
    allData.push("Wave = " + cell.Wave);
    if (cell.PowerLevel658)
        allData.push("Power 658 =" + cell.PowerLevel658);
    if (cell.PowerLevel852)
        allData.push("Power 852 = " + cell.PowerLevel852);
    allData.push("Duration = " + cell.Duration);
    allData = allData.concat(parseRepeatDataCSV(cell.Repeat));
    return allData.join(" - ");
}


function parseRepeatDataCSV(repeat) {
    var repeatData = [];
    if (repeat != null) {
        repeatData.push("Repeat type = " + repeat.RepeatType);
        if (repeat.RepeatTypeID == enums.PLAN_REPEAT.WEEKLY)// || repeat.repeatTypeID == enums.PLAN_REPEAT.BIWEEKLY)
        {
            repeatData.push("Repeat day = " + weekday[repeat.RepeatDay[0]]);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.BIWEEKLY) {
            repeatData.push("Repeat days = " + weekday[repeat.RepeatDay[0]], weekday[repeat.RepeatDay[1]]);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.MONTHLY) {
            repeatData.push("Repeat date = every " + repeat.RepeatDay[0]);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.FREE) {
            var repeatDates = '';
            for (var i = 0; i < repeat.RepeatDates.length; i++) {
                console.log(repeat.RepeatDates[i])
                if (i != 0)
                    repeatDates += ", ";
                repeatDates += repeat.RepeatDates[i];
            }

            repeatData.push("Repeat dates = " + repeatDates);
        }
    }
    return repeatData.join();
}

function RFFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {
        cell.firstRow = "Power = " + cell.PowerLevel;

        var allData = [];
        allData.push(<div key="Duration">Duration = {cell.Duration}</div>);

        allData = allData.concat(parseRepeatData(cell.Repeat));

        cell.allData = allData;

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}

function RFFormaterCSV(cell) {
    if (cell == null) {
        return "";
    }

    var allData = [];
    allData.push("Power =" + cell.PowerLevel);
    allData.push("Duration = " + cell.Duration);
    allData = allData.concat(parseRepeatDataCSV(cell.Repeat));
    return allData.join(" - ");
}

function EMTFormater(cell, row) {
    if (cell != null && cell.IsActive == true) {
        cell.firstRow = "Power = " + cell.PowerLevel;

        var allData = [];
        allData.push(<div key="Duration">Duration = {cell.Duration}</div>);

        allData = allData.concat(parseRepeatData(cell.Repeat));

        cell.allData = allData;

        return cell.firstRow;
    } else {
        return `${""}`;
    }
}

function parseRepeatData(repeat) {
    var repeatData = [];
    if (repeat != null) {
        repeatData.push(<div key="type">Repeat type = {repeat.RepeatType}</div>);
        if (repeat.RepeatTypeID == enums.PLAN_REPEAT.WEEKLY)// || repeat.repeatTypeID == enums.PLAN_REPEAT.BIWEEKLY)
        {
            repeatData.push(<div key="day">Repeat day = {weekday[repeat.RepeatDay[0]]}</div>);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.BIWEEKLY) {
            repeatData.push(<div key="days">Repeat days = {weekday[repeat.RepeatDay[0]]}, {weekday[repeat.RepeatDay[1]]}</div>);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.MONTHLY) {
            repeatData.push(<div key="date">Repeat date = every {repeat.RepeatDay[0]}'th</div>);
        }
        else if (repeat.RepeatTypeID == enums.PLAN_REPEAT.FREE) {
            var repeatDates = '';
            for (var i = 0; i < repeat.RepeatDates.length; i++) {
                if (i != 0)
                    repeatDates += ", ";
                repeatDates += repeat.RepeatDates[i];
            }

            repeatData.push(<div key="dates">Repeat dates = {repeatDates}</div>);
        }
    }
    return repeatData;
}


var date = new Date(),
    y = date.getFullYear(),
    m = date.getMonth();

function getDefaultParams() {
    const DefaultParams = {
        fromDate: new Date(y, m, 1),
        toDate: new Date(y, m + 1, 0),
        user: {
            ID: 0,
            text: ''
        }
    }
    return DefaultParams;
}



// WEBPACK FOOTER //
// ./modules/doctorSummary/DoctorAdvices.jsx